<script setup lang="ts">
/** 1.e Attendance Sheet. 서명 = 참석 주주([[Signers]] = AgmSigners 위젯). */
import CddVarField from '../../aura/agm/cdd/CddVarField.vue';
import AgmSigners from '../../aura/agm/cdd/AgmSigners.vue';
import '../../aura/agm/docs/agmDoc.css';
</script>

<template>
  <div class="agm-doc">
    <div class="doc-head" style="text-align:center">
      <div class="doc-company"><CddVarField field-key="company_name" label="Company Name" /></div>
      <div>(Incorporated in the Republic of Singapore)</div>
      <div>Unique Entity Number: <CddVarField field-key="company_uen" label="UEN" /></div>
      <div>(“the Company”)</div>
    </div>

    <p class="sec-title" style="text-align:center;letter-spacing:3px;margin-top:14px">A T T E N D A N C E &nbsp;&nbsp; S H E E T</p>

    <p class="doc-p">ATTENDANCE AT THE <CddVarField field-key="agm_number" label="AGM number (e.g. 20th)" /> ANNUAL GENERAL MEETING OF THE COMPANY HELD ON <CddVarField field-key="meeting_date" label="Meeting date" /> AT <CddVarField field-key="meeting_time" label="Meeting time" /> AT <CddVarField field-key="registered_office_address" label="Registered office address" /> .</p>

    <p class="sec-title" style="text-align:center;letter-spacing:3px">P R E S E N T</p>

    <!-- [[Signers]] — 참석 주주 서명(AgmSigners 위젯). 'Members Present' 라벨은
         바로 위 'P R E S E N T' 와 중복이라 표시하지 않는다(고객 요청). -->
    <!-- 1인 가운데 고정(패널 signBlockLayout 'attendance') — 옵션 잠금 -->
    <AgmSigners var-key="agm_member_Signers" center-locked />
  </div>
</template>

<style scoped>
.doc-company { font-weight: 800; font-size: 13.5px; }
</style>
